import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

export interface Feature {
  name: string
  variation: number
}

interface GetUserFeaturesResponse {
  features: Feature[]
}

interface AddFeatureForUserBody {
  featureName: string
  variation: number
}

const ABFeaturesApi = rtkApi.injectEndpoints({
  endpoints(build) {
    return {
      getCuratorFeatureFlags: build.query<GetUserFeaturesResponse, void>({
        query: () => ({
          url: `${APP.TIKTOK_SERVER}/curator/features/flags/by-user`,
        }),
        providesTags: ['Features'],
      }),
      updateCuratorFeatureFlags: build.mutation<unknown, AddFeatureForUserBody>(
        {
          query: (feature) => ({
            url: `${APP.TIKTOK_SERVER}/curator/features/flags/by-user`,
            method: 'PUT',
            body: feature,
          }),
          invalidatesTags: ['Features', 'TikTokMinBudget'],
        },
      ),
      getArtistFeatureFlags: build.query<GetUserFeaturesResponse, void>({
        query: () => ({
          url: `${APP.TIKTOK_SERVER}/artist/features/flags/by-user`,
        }),
        providesTags: ['Features'],
      }),
      updateArtistFeatureFlags: build.mutation<unknown, AddFeatureForUserBody>({
        query: (feature) => ({
          url: `${APP.TIKTOK_SERVER}/artist/features/flags/by-user`,
          method: 'PUT',
          body: feature,
        }),
        invalidatesTags: ['Features', 'TikTokMinBudget'],
      }),
    }
  },
})

export const {
  useGetCuratorFeatureFlagsQuery,
  useUpdateCuratorFeatureFlagsMutation,
  useGetArtistFeatureFlagsQuery,
  useUpdateArtistFeatureFlagsMutation,
} = ABFeaturesApi
